(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-product-section]');
    if (!section || section.dataset.bound) return;
    section.dataset.bound = 'true';

    const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
    const inventoryNodes = [...section.querySelectorAll('[data-variant-inventory] [data-id]')];
    const inventoryById = Object.fromEntries(
      inventoryNodes.map((node) => [
        String(node.getAttribute('data-id')),
        {
          id: Number(node.getAttribute('data-id')),
          inventory_quantity: Number(node.getAttribute('data-qty') || 0),
          inventory_policy: node.getAttribute('data-policy') || null,
          inventory_management: node.getAttribute('data-mgmt') || null,
          available: node.getAttribute('data-available') === 'true',
        },
      ])
    );
    variants.forEach((variant) => {
      const inv = inventoryById[String(variant.id)];
      if (!inv) return;
      variant.inventory_quantity = inv.inventory_quantity;
      variant.inventory_policy = inv.inventory_policy;
      variant.inventory_management = inv.inventory_management;
      variant.available = inv.available;
    });

    const optionNames = JSON.parse(section.querySelector('[data-product-options]').textContent);
    const currency = JSON.parse(section.querySelector('[data-product-currency]').textContent);
    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-product-price]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const addLabel = section.querySelector('[data-add-label]');
    const qtyInput = section.querySelector('[data-qty-input]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const stockNote = section.querySelector('[data-stock-note]');
    const mainImage =
      section.querySelector('[data-main-image]') ||
      section.querySelector('[data-main-frame] .product-page__image') ||
      section.querySelector('.product-page__image');
    const thumbs = [...section.querySelectorAll('[data-thumb]')];

    const setMainImage = ({ src, srcset, alt, imageId }) => {
      if (!mainImage || !src) return;
      mainImage.classList.add('is-switching');
      window.requestAnimationFrame(() => {
        mainImage.src = src.startsWith('//') ? `https:${src}` : src;
        if (srcset) mainImage.srcset = srcset;
        if (alt != null) mainImage.alt = alt;
        mainImage.sizes = '(min-width: 990px) 420px, (min-width: 750px) 360px, 88vw';
        mainImage.classList.remove('is-switching');
      });

      thumbs.forEach((thumb) => {
        const active = String(thumb.getAttribute('data-image-id')) === String(imageId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (event) => {
        event.preventDefault();
        setMainImage({
          src: thumb.getAttribute('data-image-src'),
          srcset: thumb.getAttribute('data-image-srcset'),
          alt: thumb.getAttribute('data-image-alt'),
          imageId: thumb.getAttribute('data-image-id'),
        });
      });
    });

    const money = (cents) => {
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
      } catch (e) {
        return '₹' + (cents / 100).toFixed(2);
      }
    };

    const inventoryCap = (variant) => {
      if (!variant) return null;
      const tracked = Boolean(variant.inventory_management);
      const deny = variant.inventory_policy === 'deny';
      if (!tracked || !deny) return null;
      const qty = Number(variant.inventory_quantity);
      if (!Number.isFinite(qty)) return null;
      return Math.max(0, qty);
    };

    const clampQty = (value, max) => {
      let next = Math.max(1, Number(value) || 1);
      if (max != null) next = Math.min(next, Math.max(1, max));
      return next;
    };

    const updateStockNote = (variant) => {
      if (!stockNote) return;
      const max = inventoryCap(variant);
      stockNote.classList.remove('is-low');
      if (max == null) {
        stockNote.textContent = '';
        return;
      }
      if (max < 1) {
        stockNote.textContent = 'Out of stock';
        stockNote.classList.add('is-low');
      } else if (max <= 5) {
        stockNote.textContent = `Only ${max} left`;
        stockNote.classList.add('is-low');
      } else {
        stockNote.textContent = `${max} in stock`;
      }
    };

    const applyQtyLimit = (variant) => {
      if (!qtyInput) return;
      const max = inventoryCap(variant);
      if (max == null) {
        qtyInput.removeAttribute('max');
        if (qtyPlus) qtyPlus.disabled = false;
      } else {
        qtyInput.max = String(Math.max(0, max));
        if (max < 1) {
          qtyInput.value = '1';
          if (qtyPlus) qtyPlus.disabled = true;
        } else {
          qtyInput.value = String(clampQty(qtyInput.value, max));
          if (qtyPlus) qtyPlus.disabled = Number(qtyInput.value) >= max;
        }
      }
    };

    const selectedOptions = () => {
      return optionNames.map((_, index) => {
        const checked = form.querySelector(`[data-option-input][data-option-position="${index + 1}"]:checked`);
        return checked ? checked.value : null;
      });
    };

    const findVariant = () => {
      const opts = selectedOptions();
      return variants.find((variant) =>
        variant.options.every((opt, i) => !opts[i] || opts[i] === opt)
      );
    };

    const updateUI = () => {
      const variant = findVariant();
      form.querySelectorAll('[data-option-selected]').forEach((el) => {
        const fieldset = el.closest('[data-option-index]');
        const checked = fieldset.querySelector('[data-option-input]:checked');
        if (checked) el.textContent = checked.value;
      });

      form.querySelectorAll('.product-page__value').forEach((label) => {
        label.classList.toggle('is-selected', label.querySelector('input')?.checked);
      });

      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        if (stockNote) stockNote.textContent = '';
        return;
      }

      variantInput.value = variant.id;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML = `<span class="product-page__price-sale">${money(variant.price)}</span><s>${money(variant.compare_at_price)}</s>`;
      } else {
        priceEl.innerHTML = `<span>${money(variant.price)}</span>`;
      }

      if (variant.featured_image?.id) {
        const thumb = thumbs.find((t) => String(t.getAttribute('data-image-id')) === String(variant.featured_image.id));
        if (thumb) {
          setMainImage({
            src: thumb.getAttribute('data-image-src'),
            srcset: thumb.getAttribute('data-image-srcset'),
            alt: thumb.getAttribute('data-image-alt'),
            imageId: thumb.getAttribute('data-image-id'),
          });
        } else if (variant.featured_image.src) {
          setMainImage({
            src: variant.featured_image.src,
            srcset: null,
            alt: variant.featured_image.alt || variant.name || '',
            imageId: variant.featured_image.id,
          });
        }
      }

      applyQtyLimit(variant);
      updateStockNote(variant);

      const max = inventoryCap(variant);
      const stockBlocked = max != null && max < 1;
      const canSell = variant.available && !stockBlocked;
      addBtn.disabled = !canSell;
      addLabel.textContent = canSell ? 'Add to cart' : 'Sold out';
    };

    form.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', updateUI);
    });

    qtyPlus?.addEventListener('click', () => {
      const variant = findVariant();
      const max = inventoryCap(variant);
      if (max != null && Number(qtyInput.value || 1) >= max) {
        (window.thorToast || window.toast)?.error?.(`Only ${max} available in stock`);
        qtyPlus.disabled = true;
        return;
      }
      qtyInput.value = String(clampQty(Number(qtyInput.value || 1) + 1, max));
      if (qtyPlus && max != null) qtyPlus.disabled = Number(qtyInput.value) >= max;
    });
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const max = inventoryCap(findVariant());
      qtyInput.value = String(clampQty(Number(qtyInput.value || 1) - 1, max));
      if (qtyPlus && max != null) qtyPlus.disabled = Number(qtyInput.value) >= max;
    });
    qtyInput?.addEventListener('change', () => {
      const max = inventoryCap(findVariant());
      const before = Number(qtyInput.value || 1);
      const next = clampQty(qtyInput.value, max);
      qtyInput.value = String(next);
      if (max != null && before > max) {
        (window.thorToast || window.toast)?.error?.(`Only ${max} available in stock`);
      }
      if (qtyPlus && max != null) qtyPlus.disabled = next >= max;
    });

    section.querySelectorAll('[data-clear-option]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const pos = btn.getAttribute('data-option-position');
        form.querySelectorAll(`[data-option-input][data-option-position="${pos}"]`).forEach((input) => {
          input.checked = false;
        });
        updateUI();
      });
    });

    // Block Buy it now / dynamic checkout when qty exceeds stock
    form.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest('.shopify-payment-button')) return;
        const variant = findVariant();
        const max = inventoryCap(variant);
        if (max == null) return;
        const qty = clampQty(qtyInput?.value || 1, max);
        qtyInput.value = String(qty);
        if (max < 1 || Number(qtyInput.value) > max) {
          event.preventDefault();
          event.stopPropagation();
          (window.thorToast || window.toast)?.error?.(
            max < 1 ? 'This item is out of stock' : `Only ${max} available in stock`
          );
        }
      },
      true
    );

    form.addEventListener('submit', async (event) => {
      if (event.submitter?.closest?.('.shopify-payment-button')) {
        const variant = findVariant();
        const max = inventoryCap(variant);
        if (max != null) {
          const qty = Number(qtyInput?.value || 1);
          if (max < 1 || qty > max) {
            event.preventDefault();
            qtyInput.value = String(clampQty(qty, max));
            (window.thorToast || window.toast)?.error?.(
              max < 1 ? 'This item is out of stock' : `Only ${max} available in stock`
            );
          }
        }
        return;
      }

      event.preventDefault();
      if (addBtn.disabled) return;

      const toast = window.thorToast || window.toast;
      const variant = findVariant();
      const max = inventoryCap(variant);
      const root = window.Shopify?.routes?.root || '/';

      let alreadyInCart = 0;
      try {
        const cartRes = await fetch(`${root}cart.js`);
        const cart = await cartRes.json();
        alreadyInCart = (cart.items || [])
          .filter((item) => Number(item.id) === Number(variantInput.value))
          .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      } catch (_) {}

      const remaining = max == null ? null : Math.max(0, max - alreadyInCart);
      const requested = Math.max(1, Number(qtyInput?.value || 1));

      if (remaining != null && requested > remaining) {
        qtyInput.value = String(Math.max(1, remaining || 1));
        if (qtyPlus && max != null) qtyPlus.disabled = Number(qtyInput.value) >= max;
        toast?.error?.(
          remaining < 1
            ? alreadyInCart > 0
              ? 'All available stock for this item is already in your cart'
              : 'This item is out of stock'
            : `Only ${max} available in stock`
        );
        return;
      }

      const quantity = remaining == null ? requested : Math.min(requested, remaining);

      const loadingId = toast?.loading?.('Adding to bag…');
      addBtn.disabled = true;

      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity,
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');

        toast?.success?.(`${data.product_title || 'Item'} added to bag`, loadingId ? { id: loadingId } : undefined);

        try {
          const cartRes = await fetch(`${root}cart.js`);
          const cart = await cartRes.json();
          const cartLink = document.querySelector('.site-header__icon[aria-label="Cart"]');
          if (cartLink) {
            let count = cartLink.querySelector('sup');
            if (cart.item_count > 0) {
              if (!count) {
                count = document.createElement('sup');
                cartLink.appendChild(count);
              }
              count.textContent = String(cart.item_count);
            } else if (count) {
              count.remove();
            }
          }
        } catch (_) {}
      } catch (err) {
        toast?.error?.(err.message || 'Could not add to cart', loadingId ? { id: loadingId } : undefined);
      } finally {
        const current = findVariant();
        const currentMax = inventoryCap(current);
        const stockBlocked = currentMax != null && currentMax < 1;
        addBtn.disabled = !(current && current.available && !stockBlocked);
      }
    });

    updateUI();
  })();

  } catch(e) { console.error(e); }
})();
})();
